let load = require('./helpers/browser/esm-js-loader');
module.exports = (load("kgybg")).then(() => parcelRequire('dEERs'));